'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UITruncateString from 'UIComponents/text/UITruncateString';
import NetworkIcon from '../NetworkIcon';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import Small from 'UIComponents/elements/Small';
import UIStatusTag from 'UIComponents/tag/UIStatusTag';
import UITableHoverCell from 'UIComponents/table/UITableHoverCell';
import UIButton from 'UIComponents/button/UIButton';
import ScopeWrapper from '../ScopeWrapper';
import UILink from 'UIComponents/link/UILink';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import CurrentUserNotConnected from '../CurrentUserNotConnected';
import { AdCreationTypes } from 'AdsUI/lib/Constants';

const DraftLink = ({
  canCreateAds,
  needsMarketableContactsPermission,
  network,
  onClick,
  children
}) => {
  if (!canCreateAds || needsMarketableContactsPermission) {
    return /*#__PURE__*/_jsx(UITooltip, {
      title: !canCreateAds ? /*#__PURE__*/_jsx(CurrentUserNotConnected, {
        network: network,
        action: "createAds"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: !canCreateAds ? 'campaigns.drafts.noPermission' : 'marketingContactsPermissions'
      }),
      children: /*#__PURE__*/_jsx(UILink, {
        disabled: true,
        children: children
      })
    });
  }

  return /*#__PURE__*/_jsx(UILink, {
    onClick: onClick,
    children: children
  });
};

const DraftRow = ({
  draft,
  adAccount,
  canCreateMarketableContacts,
  onClick,
  onDelete
}) => {
  const needsMarketableContactsPermission = draft.displayType === AdCreationTypes.LEAD_AD && !canCreateMarketableContacts;
  return /*#__PURE__*/_jsxs("tr", {
    children: [/*#__PURE__*/_jsx(UITableHoverCell, {
      hoverContent: /*#__PURE__*/_jsx(ScopeWrapper, {
        tooltipKey: "deleteDrafts",
        children: /*#__PURE__*/_jsx(UIButton, {
          use: "tertiary-light",
          size: "extra-small",
          onClick: onDelete,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "deleteButton"
          })
        })
      }),
      children: /*#__PURE__*/_jsxs(UIMediaObject, {
        itemLeft: /*#__PURE__*/_jsx(NetworkIcon, {
          network: draft.adNetwork
        }),
        align: "center",
        children: [/*#__PURE__*/_jsx(DraftLink, {
          onClick: onClick,
          canCreateAds: adAccount.canCreateAds,
          needsMarketableContactsPermission: needsMarketableContactsPermission,
          network: adAccount.network,
          children: /*#__PURE__*/_jsx(UITruncateString, {
            className: "m-bottom-1 m-top-2",
            children: draft.name
          })
        }), /*#__PURE__*/_jsx(UIStatusTag, {
          use: "default",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "campaigns.drafts.draftStatus"
          })
        })]
      })
    }), /*#__PURE__*/_jsx("td", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `campaigns.drafts.types.${draft.displayType}`
      })
    }), /*#__PURE__*/_jsx("td", {
      children: adAccount.getShortName()
    }), /*#__PURE__*/_jsxs("td", {
      children: [/*#__PURE__*/_jsx(FormattedDateTime, {
        value: draft.updatedAt || draft.createdAt,
        format: "lll"
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(Small, {
          use: "help",
          children: draft.updatedByHubSpotUserName
        })
      })]
    })]
  });
};

export default DraftRow;